module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "mini_card",
    attrs: {
      "to": {
        name: _vm.routeName,
        params: {
          id: _vm.id
        }
      }
    }
  }, [_c('AppPicture', {
    attrs: {
      "image": _vm.image,
      "alt": _vm.title
    }
  }), _c('main', {
    staticClass: "mini_card__main"
  }, [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "center, bold, uppercase"
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1), _c('MoreButton', {
    staticClass: "mini_card__btn"
  }, [_vm._v("Подробнее")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46dee3f0","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/event/card/components/MiniCard.vue
// module id = ca55dfa4d2e1a74bdc72
// module chunks = 6